module.exports = __webpack_public_path__ + "media/images/social-share-button/weibo-20a80f206cb23e64c5563a35add9d8d5.svg";